




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ObjectType, Scoring } from '@/@types/graphql-types';

import OfferReporterModalGraphql from '@/components/modals/offer-reporter/OfferReporterModalGraphql.vue';

import { ModalHelper } from '@/helpers/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleOfferFragment } from './graphql/fragments/Offer.fragment';

@Component({ name: 'OfferReporterGraphql' })
export default class OfferReporterGraphql extends Vue {
	@Prop({ required: true }) titleId: string;
	@Prop({ required: true }) titleObjectId: number;
	@Prop({ required: true }) titleObjectType: ObjectType;
	@Prop({ required: true }) titleName: string;
	@Prop({ default: '' }) originalReleaseYear: number;
	@Prop({ default: () => ({}) }) titleScoring: Scoring;
	@Prop({ default: () => [] }) titleOffers: TitleOfferFragment[];
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];

	openModal() {
		ModalHelper.openModal(
			OfferReporterModalGraphql,
			{
				titleId: this.titleId,
				titleObjectId: this.titleObjectId,
				titleObjectType: this.titleObjectType,
				titleName: this.titleName,
				originalReleaseYear: this.originalReleaseYear,
				titleScoring: this.titleScoring,
				titleOffers: this.titleOffers,
			},
			{},
			'',
			false,
			this.additionalContexts
		);
	}
}
